module.exports = __webpack_public_path__ + "images/avatars/female/17.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/17.svg
// module id = SHV6
// module chunks = 153